import React from 'react'
import StarIcon from './StarIcon'
import './styles.css'

export default function RatingIcon(props) {
    const {
      index,
      rating,
      hoverRating,
      onMouseEnter,
      onMouseLeave,
      onSaveRating,
      className,
      width= '15px'
    } = props;
    const fill = React.useMemo(() => {
      if (hoverRating >= index) {
        return '#FFAD0E,'////'#919191';
      } else if (!hoverRating && rating >= index) {
        return '#FFAD0E' //'#919191';
      }
      return '#DEE3EA';
    }, [rating, hoverRating, index]);
    const fillLine = React.useMemo(() => {
        if (hoverRating >= index) {
          return '#FFAD0E'////'#919191';
        } else if (!hoverRating && rating >= index) {
          return '#FFAD0E' //'#919191';
        }
        return '#DEE3EA';
      }, [rating, hoverRating, index]);
  return (
        <div key={index}
          className={`${className} h-100 cursor-pointer d-flex `}
          style={{width: width, color: fillLine}}
          onMouseEnter={() => onMouseEnter(index)} 
          onMouseLeave={() => onMouseLeave()} 
          onClick={() => onSaveRating(index)}>
          <StarIcon fill={fill} />
        </div>
    )
  }
